import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { Trash2, Scale, Share2 } from "lucide-react";

export const HistoryCard = ({ item, catLabel, compared, onShare, onCompare, onDelete }) => {
  const { t, lang } = useLang();

  return (
    <div data-testid={`history-item-${item.id}`} className="border border-black bg-white p-6 hover:shadow-hard-sm hover:-translate-y-1 transition-all">
      <div className="flex items-center justify-between">
        <span className="font-mono text-[10px] text-[#737373]">{new Date(item.created_at).toLocaleString(lang === "it" ? "it-IT" : "en-US")}</span>
        <div className="flex items-center gap-2 lg:gap-1">
          <button
            data-testid={`history-share-${item.id}`}
            onClick={onShare}
            className="p-3 lg:p-1 text-[#737373] hover:bg-[#002FA7] hover:text-white transition-colors"
            title={t.dashboard.share}
          >
            <Share2 size={14} />
          </button>
          <button
            data-testid={`history-compare-${item.id}`}
            onClick={onCompare}
            className={`p-3 lg:p-1 transition-colors ${compared ? "bg-black text-white" : "text-[#737373] hover:bg-black hover:text-white"}`}
            title={t.dashboard.compare}
          >
            <Scale size={14} />
          </button>
          <button data-testid={`history-delete-${item.id}`} onClick={onDelete} className="text-[#FF3B30] hover:bg-[#FF3B30] hover:text-white p-3 lg:p-1 transition-colors" title={t.dashboard.delete}>
            <Trash2 size={14} />
          </button>
        </div>
      </div>
      <div className="mt-3">
        <div className="font-display font-bold text-lg leading-tight">{item.input.brand || "—"} {item.input.model}</div>
        <div className="font-mono text-xs text-[#737373] uppercase mt-1">{catLabel(item.input.category)} · {t.valuator.conditions[item.input.condition] || item.input.condition}</div>
      </div>
      <div className="mt-5 border-t border-black/10 pt-4 grid grid-cols-3 gap-2 text-center">
        {item.result.strategies.map((s) => (
          <div key={s.goal}>
            <div className="overline text-[9px] text-[#737373]">{s.goal.slice(0, 3).toUpperCase()}</div>
            <div className="font-mono font-bold text-sm">€{Number(s.price).toFixed(0)}</div>
          </div>
        ))}
      </div>
      <div className="mt-4">
        <div className="overline text-[#737373]">{t.results.market_value}</div>
        <div className="font-display font-black text-2xl tracking-tighter mt-1">
          €{Number(item.result.estimated_market_value).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </div>
      </div>
    </div>
  );
};

export default HistoryCard;
